export const mockTotalRewardsEarned = 'XXXX.XX';
export const mockCashbackPercentage = 'XX';

export type RewardDataExists = {
  breakdownData: boolean;
  purchasesData: boolean;
};
